import React, { FC } from 'react';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Tooltip,
    IconButton,
    Button,
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Chip
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';

import { TemplateAccordionProps } from './types';

const AssessmentTemplateDetailAccordion: FC<TemplateAccordionProps> = ({
    section,
    canEdit,
    onCreateDetail,
    onEditTemplate,
    onEditDetail,
    onRemoveTemplate,
    onRemoveDetail,
    getAdequacyChipStyles,
    classes
}) => {
    const { template, details, expanded, onToggle, panelId } = section;

    return (
        <Accordion
            key={panelId}
            className={classes.templateAccordion}
            square
            expanded={expanded}
            onChange={onToggle}
            TransitionProps={{ unmountOnExit: true }}
            style={{ width: '100%' }}
        >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    style={{ backgroundColor: '#f3f3f3' }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <Typography variant="body1" style={{ fontWeight: 500 }}>
                            {template.name}
                    </Typography>
                    {canEdit && (
                        <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
                            <Tooltip title="Add detail">
                                <IconButton
                                    size="small"
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        onCreateDetail(template);
                                    }}
                                >
                                    <AddCircleOutlineIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Edit template">
                                <IconButton
                                    size="small"
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        onEditTemplate(template);
                                    }}
                                >
                                    <EditIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Remove template">
                                <IconButton
                                    size="small"
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        onRemoveTemplate(template);
                                    }}
                                    disabled={!template.uuid}
                                >
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </div>
                    )}
                </div>
            </AccordionSummary>
            <AccordionDetails style={{ display: 'block', width: '100%' }}>
                <Typography variant="body2" color="textSecondary">
                    {(template as any).description || '-'}
                </Typography>
                {canEdit && (
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
                        <Button
                            size="small"
                            color="primary"
                            startIcon={<AddIcon />}
                            onClick={() => onCreateDetail(template)}
                        >
                            Add detail
                        </Button>
                    </div>
                )}
                {details.length === 0 ? (
                    <Typography variant="body2" style={{ marginTop: 8 }}>No details for this template.</Typography>
                ) : (
                    <TableContainer component={Paper} style={{ boxShadow: 'none', marginTop: 12 }}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.tableHeaderCell}>Adequacy</TableCell>
                                    <TableCell className={classes.tableHeaderCell}>Description</TableCell>
                                    {canEdit && <TableCell className={classes.tableHeaderCell}>Actions</TableCell>}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {details.map(detail => (
                                    <TableRow key={detail.uuid}>
                                        <TableCell>
                                            <Chip
                                                size="small"
                                                label={detail.adequacy?.name || 'Undefined'}
                                                style={getAdequacyChipStyles(detail.adequacy?.level)}
                                            />
                                        </TableCell>
                                        <TableCell>{(detail as any).description || (detail as any).justification || '-'}</TableCell>
                                        {canEdit && (
                                            <TableCell>
                                                <Tooltip title="Edit detail">
                                                    <IconButton size="small" onClick={() => onEditDetail(detail, template)}>
                                                        <EditIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Remove detail">
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => onRemoveDetail(detail, template)}
                                                        disabled={!detail.uuid}
                                                    >
                                                        <DeleteIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        )}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </AccordionDetails>
        </Accordion>
    );
};

export default AssessmentTemplateDetailAccordion;
